import { message } from "antd";
import { useState } from "react";
import { EditIconButton } from "common/components/iconButton/editIconButton";
import K from "utilities/constants";
import Client from "redux/models/client";
import { EditJobModal } from "./editJobModal";

export const EditJobButton = ({ clientId, job, onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDuplicate, setIsDuplicate] = useState(false);

  const handleCancel = () => {
    setOpen(false);
    setIsDuplicate(false);
  };

  const handleDuplicate = () => setIsDuplicate(true);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      if (isDuplicate) {
        const body = {
          ...values,
          clientsId: clientId,
          recruitingStartDate: values.recruitingStartDate.format(
            K.DateFormat.Response,
          ),
        };

        const res = await Client.addClientJobs(body);
        handleCancel();
        onSuccess?.(res);
        message.success("Job Created Successfully");
      } else {
        const body = { ...values, jobSourceId: job.id, clientsId: clientId };
        const res = await Client.editClientJobs(body);
        handleCancel();
        onSuccess?.(res);
        message.success("Job Updated Successfully");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <EditIconButton onClick={() => setOpen(true)} />

      {open && (
        <EditJobModal
          clientId={clientId}
          job={job}
          open={open}
          loading={loading}
          isDuplicate={isDuplicate}
          onDuplicate={handleDuplicate}
          onCancel={handleCancel}
          onFinish={onFinish}
        />
      )}
    </>
  );
};
